module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_gsshop_m2.c821e04c0253a92c51c720b6ee50a371.png";